import React from "react";

const Footer = () => {
  return (
    <section className="d-flex pb-3 justify-content-lg-between  footer">
     
      <div className="col-md-3 mt-2 d-flex justify-content-center f600">
        <div className="">Copyright 2021 ABE Digital Solutions LTD.</div>
      </div>
    </section>
  );
};

export default Footer;
